module.exports = __webpack_public_path__ + "media/images/top/rank3_bg-7d1cee859458df10dfc530b1c7b3aaf1.gif";